import { createAction } from 'redux-actions';
import * as Actions from '../constants/actions';
import { GroupData } from '../models/Group';
import { StudentData, groupWithStudentCredentials } from '../models/Student';
import { CampaignData } from '../models/Campaign';

export const setGroups = createAction<GroupData[]>(Actions.SET_GROUPS);
export const addGroup = createAction<GroupData>(Actions.ADD_GROUP);
export const deleteGroup = createAction<GroupData>(Actions.DELETE_GROUP);
export const addStudent = createAction<StudentData>(Actions.ADD_STUDENT);
export const updateStudentNames = createAction<StudentData>(Actions.UPDATE_STUDENT_NAMES);
export const updateStudentCredentials = createAction<groupWithStudentCredentials>(Actions.UPDATE_STUDENT_CREDENTIALS);
export const deleteStudent = createAction<StudentData>(Actions.DELETE_STUDENT);
export const addCampaign = createAction<CampaignData>(Actions.ADD_CAMPAIGN);
export const updateCampaign = createAction<CampaignData>(Actions.UPDATE_CAMPAIGN);
export const deleteCampaign = createAction<CampaignData>(Actions.DELETE_CAMPAIGN);
export const updatePermissions = createAction<GroupData>(Actions.UPDATE_PERMISSIONS);


// WEBPACK FOOTER //
// ./~/tslint-loader!./react/narrapix/src/actions/group.ts